module.exports = __webpack_public_path__ + "img/amendment.13cd015c.svg";